<template>
    <div>
        <h1 class="mb-3 border-b border-gray-200 pb-2 module-header">Danger Zone</h1>

        <table v-if="! viewOnlyMode">
            <thead>
            <tr>
                <th class="pl-2">Field</th>
                <th>Value</th>
            </tr>
            </thead>
            <!-- <tbody>
                <tr>
                    <td class="pl-2">CMBS</td>
                    <td class="pl-2"><textarea v-model="building.cmbs" rows="9" cols="80" class="p-3 border border-gray-200 rounded-lg shadow-sm"></textarea></td>
                </tr>
                <tr>
                    <td class="pl-2">DSCR</td>
                    <td class="pl-2">
                        <number-input v-model="building.dscr" is-decimal></number-input>
                    </td>
                </tr>
                <tr>
                    <td class="pl-2">Watchlist Note</td>
                    <td class="pl-2"><textarea v-model="building.watchlist_note" rows="9" cols="80" class="p-3 border border-gray-200 rounded-lg shadow-sm"></textarea></td>
                </tr>
            </tbody> -->
            <tbody>
                <tr>
                    <td class="pl-2 relative">
                        <span>CMBS</span>
                        <div class="absolute top-0 right-1">
                            <InfoIcon identifier="sites-dangerzone-cmbs" />
                        </div>
                    </td>
                    <td class="pl-2">
                        <textarea v-model="building.cmbs" rows="9" cols="80"
                            class="p-3 border border-gray-200 rounded-lg shadow-sm"></textarea>
                    </td>
                </tr>
                <tr>
                    <td class="pl-2 relative">
                        <span>DSCR</span>
                        <div class="absolute top-0 right-1">
                            <InfoIcon identifier="sites-dangerzone-dscr" />
                        </div>
                    </td>
                    <td class="pl-2">
                        <number-input v-model="building.dscr" is-decimal></number-input>
                    </td>
                </tr>
                <tr>
                    <td class="pl-2 relative">
                        <span>Watchlist Note</span>
                        <div class="absolute top-0 right-1">
                            <InfoIcon identifier="sites-dangerzone-watchlistnote" />
                        </div>
                    </td>
                    <td class="pl-2">
                        <textarea v-model="building.watchlist_note" rows="9" cols="80"
                            class="p-3 border border-gray-200 rounded-lg shadow-sm"></textarea>
                    </td>
                </tr>
            </tbody>

        </table>

        <div v-if="viewOnlyMode" class="mb-96">
            <div class="flex gap-x-20">
                <div class="flex flex-col">
                    <label>CMBS</label>
                    <div class="max-w-prose">{{ building.cmbs || "No Data Found"}}</div>
                </div>
                <div class="flex flex-col">
                    <label>DSCR</label>
                    <div>{{ building.dscr || "No Data Found"}}</div>
                </div>
                <div class="flex flex-col">
                    <label>Watchlist Note</label>
                    <div class="max-w-prose">{{ building.watchlist_note || "No Data Found"}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        buildingData: {
            type: Object,
            required: true
        },

        viewOnlyMode: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(['buildings']),

        building() {
            return this.buildings.selectedBuilding;
        },
    },

    methods: {

    }
}
</script>
